import * as React from "react";

import type { RefObjectFunction } from "@fluentui/react-hooks";

import { InputMethod } from "@1js/acui-common";

import type {
  AppComponentKeytipOptions,
  AppComponentKeytipProps,
  AppComponentWithKeytip,
} from "./useAppComponentKeytip";

export const useOnExecuteFromKeytip: <TProps extends AppComponentKeytipProps>(
  props: TProps,
  ref: RefObjectFunction<HTMLElement | null | undefined>,
  type: AppComponentWithKeytip,
  options?: AppComponentKeytipOptions
) => () => void = (props, ref, type, options) => {
  const {
    checked = false,
    id,
    location,
    onExecute,
    shouldTakeFocus,
    toggled = false,
  } = props;
  const { useDirectClick, directClickRef } = options || {};

  // Execution could mean either directly clicking the control, or (where possible) only dispatching onExecute command
  const executeFromKeytip = React.useCallback(() => {
    if (useDirectClick) {
      directClickRef ? directClickRef.current?.click() : ref?.current?.click();
    } else if (onExecute) {
      switch (type) {
        case "AppButton":
          onExecute({
            id,
            location,
            toggled,
            inputMethod: InputMethod.Keyboard,
            shouldTakeFocus,
          });
          break;

        case "AppCheckbox":
          onExecute({
            checked: !checked,
            id,
            location,
          });
          break;

        // AppCombobox has no custom logic executed from the keytip
      }
    }
  }, [
    checked,
    directClickRef,
    id,
    location,
    onExecute,
    ref,
    shouldTakeFocus,
    toggled,
    type,
    useDirectClick,
  ]);

  return executeFromKeytip;
};
